import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';

(function (jQuery) {
  jQuery.gfRepeator = function (element, options) {
    const defaults = {
      targetElement: undefined,
      render: false,
      detectChange: function () {},
      onHistoryAdded: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);

    const _this = this;

    let dataHolder;
    let _jsonData = {};
    let $targetElement;
    let $wrapper;

    let _isRender;

    /* Editor */
    const $gfLeftSideBar = getGlobalVariable('gfLeftSideBar');

    /* Iframe */
    const $gryffEditor = getGlobalVariable('gryffEditor');
    const $gryffBody = getGlobalVariable('gryffBody');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $targetElement = _this.settings.targetElement;
      _isRender = _this.settings.render;

      if (this.settings.dataHolder != undefined) {
        dataHolder = this.settings.dataHolder;
        try {
          _jsonData = jQuery.parseJSON(dataHolder);
        } catch (err) {
          console.log(err.message);
        }
        this.initWithJson();
      }

      $wrapper = $element.closest('.columns');
      $wrapper.addClass('full');
      return false;
    };

    this.initWithJson = function (jsonData) {
      if (jsonData != undefined) {
        _jsonData = jsonData;
        _isRender = true;
      }
      this.renderRepeator();
      this.applyEvents();

      return false;
    };

    this.renderField = function (object, index) {
      let html = '';
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          // disable field;
          // COLLECTION 2019
          if (
            object[key] == 'Facebook' ||
            object[key] == 'Twitter' ||
            object[key] == 'Pinterest' ||
            object[key] == 'Google Plus' ||
            object[key] == 'Email' ||
            object[key] == 'Linked In' ||
            object[key] == 'Featured' ||
            object[key] == 'Best selling' ||
            object[key] == 'Alphabetically, A-Z' ||
            object[key] == 'Alphabetically, Z-A' ||
            object[key] == 'Price, low to high' ||
            object[key] == 'Price, high to low' ||
            object[key] == 'Date, new to old' ||
            object[key] == 'Date, old to new'
          ) {
            continue;
          }
          let name = object[key].caption;

          if (key == 'name') {
            name = 'Name';
          }
          if (name == undefined) {
            name = key;
          }
          if (name == undefined) {
            name = 'Option';
          }
          if (key != 'id') {
            if (object[key].type != undefined) {
              html += '<div class="gfPR_form-item">';
              switch (object[key].type) {
                case 'span':
                  html += '<span data-caption="' + name + '" class="gfDesc">' + object[key].default_value + '</span>';
                  break;
                case 'select':
                  html += '<select data-name="' + object[key].name + '" data-caption="' + name + '">';
                  for (const option in object[key].options) {
                    var selected = '';
                    if (object[key].default_value == option) {
                      var selected = 'selected';
                    }
                    html +=
                      '<option value="' + option + '" ' + selected + '>' + object[key].options[option] + '</option>';
                  }
                  html += '</select>';
                  break;
                default:
                  html +=
                    '<input type="text" data-name="' +
                    object[key].name +
                    '" id="item-' +
                    object[key].name +
                    '-' +
                    index +
                    '" class="' +
                    object[key].class +
                    '" value="' +
                    object[key].default_value +
                    '" data-caption="' +
                    name +
                    '" />';
                  break;
              }
              html += '</div>';
            } else {
              html += '<div class="gfPR_form-item">';
              switch (key) {
                case 'span':
                  html += '<span data-caption="' + name + '">' + object[key].default_value + '</span>';
                  break;

                case 'image':
                  html +=
                    '<input type="text" data-name="' +
                    key +
                    '" id="item-' +
                    key +
                    '-' +
                    index +
                    '" class="gf_to-photoPicker" value="' +
                    object[key] +
                    '" data-caption="' +
                    name +
                    '" />';
                  break;

                case 'icon':
                  var selectedIcon = jQuery('<div/>').html(object[key]).text();
                  html +=
                    '<input type="hidden" data-name="' +
                    key +
                    '" id="item-' +
                    key +
                    '-' +
                    index +
                    '" value="' +
                    object[key] +
                    '" data-caption="' +
                    name +
                    '" /><div class="add-icon-box"><a href="#" class="selected-icon"><i class="' +
                    selectedIcon +
                    '"></i></a> <a href="#" class="btn button gfIconPicker">Choose Icon...</a> </div>';
                  break;

                default:
                  if (key.indexOf('content') !== -1 || key.indexOf('config') !== -1) {
                  } else {
                    html +=
                      '<input type="text" data-name="' +
                      key +
                      '" id="item-' +
                      key +
                      '-' +
                      index +
                      '" value="' +
                      object[key] +
                      '" data-caption="' +
                      name +
                      '" />';
                  }
              }
              html += '</div>';
            }
          }
        }
      }
      return html;
    };

    this.renderCaption = function () {
      let caption = typeof $element.attr('data-caption') == undefined ? '' : $element.attr('data-caption');
      if (caption == '') {
        caption = 'Items';
      }
      const _template =
        '<div class="gfRP_caption"><span>' +
        caption +
        '</span><svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M8,7h3.5C11.78,7,12,7.22,12,7.5S11.78,8,11.5,8H8v3.5C8,11.78,7.78,12,7.5,12S7,11.78,7,11.5V8H3.5   C3.22,8,3,7.78,3,7.5S3.22,7,3.5,7H7V3.5C7,3.22,7.22,3,7.5,3S8,3.22,8,3.5V7z" /></svg></div>';
      $element.append(_template);
    };

    this.renderRepeator = function (jsonData) {
      if ($element.prev('.gfSGBackground').length == 0) {
        $element.before('<div class="gfSGBackground"></div>');
      }

      if (jsonData != undefined) {
        _jsonData = jsonData;
      }

      $element.find('ul.items').remove();
      let _template = '';

      _template += '<ul class="items">';
      for (let i = 0; i < _jsonData['items'].length; i++) {
        const item = _jsonData['items'][i];

        let hideClone = false;
        let hideRemove = false;

        // Hide clone;
        // COLLECTION 2019
        if (
          item.name == 'Facebook' ||
          item.name == 'Twitter' ||
          item.name == 'Pinterest' ||
          item.name == 'Google Plus' ||
          item.name == 'Email' ||
          item.name == 'Linked In' ||
          item.name == 'Featured' ||
          item.name == 'Best selling' ||
          item.name == 'Alphabetically, A-Z' ||
          item.name == 'Alphabetically, Z-A' ||
          item.name == 'Price, low to high' ||
          item.name == 'Price, high to low' ||
          item.name == 'Date, new to old' ||
          item.name == 'Date, old to new'
        ) {
          hideClone = true;
        }
        // Hide Reomove
        // COLLECTION 2019
        if (
          item.name == 'Facebook' ||
          item.name == 'Twitter' ||
          item.name == 'Pinterest' ||
          item.name == 'Google Plus' ||
          item.name == 'Email' ||
          item.name == 'Linked In' ||
          item.name == 'Featured' ||
          item.name == 'Best selling' ||
          item.name == 'Alphabetically, A-Z' ||
          item.name == 'Alphabetically, Z-A' ||
          item.name == 'Price, low to high' ||
          item.name == 'Price, high to low' ||
          item.name == 'Date, new to old' ||
          item.name == 'Date, old to new'
        ) {
          hideRemove = true;
        }

        _template +=
          '<li class="item" index="' +
          i +
          '"><div class="gfRP_confirm_remove"><button data-action="delete">Delete</button><button data-action="cancel">Cancel</button></div> <span class="gfRP_more rp-more"> <svg class="need_a_name" height="16px" viewbox="0 0 16 16"> <path d="M7,11.5c-0.13,0-0.26-0.05-0.35-0.15c-0.2-0.2-0.2-0.51,0-0.71L9.29,8L6.65,5.35c-0.2-0.2-0.2-0.51,0-0.71 s0.51-0.2,0.71,0l3,3c0.2,0.2,0.2,0.51,0,0.71l-3,3C7.26,11.45,7.13,11.5,7,11.5z" /> </svg> </span> <span class="gfRP_title rp-handle">';
        if (item.label && item.label.name) {
          // Use for gfOptions
          _template += item.label.default_value;
        } else if (item.name == undefined) {
          _template += 'Item ' + (i + 1);
        } else {
          _template += item.name;
        }
        _template += '</span><div class="gfRP_right">';

        if (!hideClone) {
          _template += '<span class="rp-clone">' + utils.svgIcon('duplicate-tool') + '</span>';
        }
        if (!hideRemove) {
          _template += '<span class="rp-remove">' + utils.svgIcon('delete-tool') + '</span>';
        }
        _template +=
          '</div> <div class="gfPR_form-items"> <div class="gfPR_columns ' +
          i +
          '"> <div class="gfSGSettings">' +
          _this.renderField(item, i) +
          '</div> </div> </div> </li>';
      }
      _template += '</ul>';

      // Render template
      $element.append(_template);

      $element.find('ul.items').sortable({
        axis: 'y',
        delay: 100,
        distance: 5,
        handle: '.rp-handle',
        placeholder: 'block-placeholder',
        cursor: 'ns-resize',
        opacity: 0.8,
        start: function (event, ui) {
          // firefox fix
          $gfLeftSideBar.focus();
          $gfLeftSideBar.off('mouseup');

          const $dad = $(ui.item);
          $dad.find('.rp-more').removeClass('active');
          $dad.find('.gfSGSettings').removeClass('show');
          $dad.removeClass('show');
        },
        update: function (event, ui) {
          // history
          const extra = {
            items: dataHolder,
          };
          $gryffEditor.data('gfhistory').addHistory('repeator', $targetElement.attr('id'), extra);

          if ($targetElement) {
            const extraCount = {
              label: $targetElement.attr('data-label'),
              name: 'move-repeator',
            };
            if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
              $gryffEditor.data('gfcount').add('setting', extraCount);
            }
          }

          const array = [];
          $element.find('ul.items .item').each(function (index) {
            array.push(jQuery(this).attr('index'));
          });

          const copyDataArray = [];
          for (let i = 0; i < array.length; i++) {
            copyDataArray.push(_jsonData['items'][array[i]]);
          }
          _jsonData['items'] = copyDataArray;
          const dataChanged = _this.saveJsonToModule();

          $element.find('ul.items .item').each(function (index) {
            jQuery(this).attr('index', index);
          });
          _this.settings.detectChange(dataChanged);
          _this.settings.onHistoryAdded();
        },
      });
    };

    this.applyEvents = function () {
      let delayOpen;
      $element
        .find('.rp-more')
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          const $that = $(this);
          clearTimeout(delayOpen);
          delayOpen = setTimeout(function () {
            //
            if (_isRender) {
              _isRender = false;
              const $column = $element.parent('.columns');
              if ($column.data('gfsettinggroup')) {
                $column.data('gfsettinggroup').setContent();
              }
            }

            $that.toggleClass('active');
            const $dad = $that.parent('.item');
            $dad.toggleClass('show');
            const $formItems = $dad.find('.gfSGSettings');
            $formItems.toggleClass('show');

            const $li = $that.parent('.item');
            $element.find('.item').css({
              'z-index': 10,
            });
            $li.css({
              'z-index': 20,
            });

            // HISTORY OPTIMIZE
            $li.find('input, select, textarea').off('focus.inputfield');

            $li.find('input, select, textarea').on('focus.repeator', function () {
              const $this = jQuery(this);
              window._isHistoryEditing = true;
              const oldValue = $this.val();
              const backupJSON = dataHolder;

              const currentTab = $gfLeftSideBar.find('.simple-tabs').data('gftabs').getCurrentTab();
              switch (currentTab) {
                case 'Settings':
                  $gryffBody.off('mousedown.history.repeator').on('mousedown.history.repeator', function (e) {
                    const $target = jQuery(e.target);

                    if (!$target.is($this)) {
                      if (oldValue != $this.val()) {
                        // history
                        const extra = {
                          items: backupJSON,
                        };
                        $gryffEditor.data('gfhistory').addHistory('repeator', $targetElement.attr('id'), extra);

                        if ($targetElement) {
                          const extraCount = {
                            label: $targetElement.attr('data-label'),
                            name: 'settings-input-repeator',
                            value: $this.val(),
                          };
                          if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                            $gryffEditor.data('gfcount').add('setting', extraCount);
                          }
                        }
                      }
                      window._isHistoryEditing = false;
                      $gryffBody.off('mousedown.history.repeator');
                      jQuery('body').off('mousedown.history.repeator');
                    }
                  });

                  jQuery('body')
                    .off('mousedown.history.repeator')
                    .on('mousedown.history.repeator', function (e) {
                      const $target = jQuery(e.target);

                      if (!$target.is($this)) {
                        if (oldValue != $this.val()) {
                          // history
                          const extra = {
                            items: backupJSON,
                          };
                          $gryffEditor.data('gfhistory').addHistory('repeator', $targetElement.attr('id'), extra);

                          if ($targetElement) {
                            const extraCount = {
                              label: $targetElement.attr('data-label'),
                              name: 'settings-input-repeator',
                              value: $this.val(),
                            };
                            if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                              $gryffEditor.data('gfcount').add('setting', extraCount);
                            }
                          }
                        }
                        window._isHistoryEditing = false;
                        $gryffBody.off('mousedown.history.repeator');
                        jQuery('body').off('mousedown.history.repeator');
                      }
                    });

                  break;

                case 'Design':
                  $gryffBody.off('mousedown.history.repeator').on('mousedown.history.repeator', function (e) {
                    const $target = jQuery(e.target);

                    if (!$target.is($this)) {
                      if (oldValue != $this.val()) {
                        const extra = {
                          flagBKDesignOptions: true,
                        };
                        _this.settings.onHistoryAdded();
                        $element.trigger('history-change', extra);
                      }
                      window._isHistoryEditing = false;
                      $gryffBody.off('mousedown.history.repeator');
                      jQuery('body').off('mousedown.history.repeator');
                    }
                  });

                  jQuery('body')
                    .off('mousedown.history.repeator')
                    .on('mousedown.history.repeator', function (e) {
                      const $target = jQuery(e.target);

                      if (!$target.is($this)) {
                        if (oldValue != $this.val()) {
                          const extra = {
                            flagBKDesignOptions: true,
                          };
                          _this.settings.onHistoryAdded();
                          $element.trigger('history-change', extra);
                        }
                        window._isHistoryEditing = false;
                        $gryffBody.off('mousedown.history.repeator');
                        jQuery('body').off('mousedown.history.repeator');
                      }
                    });

                  break;
              }
            });

            $li
              .find('input, select, textarea')
              .off('input-change')
              .on('input-change', function () {
                const $that = jQuery(this);

                const index = $li.index();

                const itemsArray = _jsonData['items'];
                const item = itemsArray[index];

                const name = $that.attr('data-name');
                const value = $that.attr('value');
                try {
                  if (item[name] && item[name].type != undefined) {
                    item[name].default_value = value;
                  } else {
                    item[name] = value;
                  }
                  // auto update name
                  if (name.indexOf('name') != -1 || name.indexOf('label') != -1) {
                    $li.find('span.gfRP_title').html(value);
                  }

                  _jsonData['items'] = itemsArray;
                  const dataChanged = _this.saveJsonToModule();
                  _this.settings.detectChange(dataChanged);
                } catch (err) {
                  console.log(err.message);
                }
                return false;
              });
          }, 100);
          return false;
        });

      // catch event
      $element
        .find('.rp-remove')
        .off()
        .on('click', function () {
          const $that = $(this);
          const $li = $that.parent().parent('.item');

          $li.find('.gfRP_confirm_remove').addClass('show');

          $li
            .find('.gfRP_confirm_remove button[data-action="cancel"]')
            .off('click')
            .on('click', function () {
              $li.find('.gfRP_confirm_remove').removeClass('show');
              $li.find('.gfRP_confirm_remove button[data-action="cancel"]').off('click');
              $li.find('.gfRP_confirm_remove button[data-action="delete"]').off('click');
            });
          $li
            .find('.gfRP_confirm_remove button[data-action="delete"]')
            .off('click')
            .on('click', function () {
              let index = $li.attr('index');

              const count = _jsonData['items'].length;
              if (count <= 1) {
                HELPER.showNotify('You cannot delete all items.', 'error');
              } else {
                const itemData = _jsonData['items'][index];

                // history + export data history
                const extra = {
                  items: dataHolder,
                  childData: {},
                };

                const $html = jQuery('<div />').html(itemData.content);
                let html = '';
                let bkHtml = '';
                let data = {};

                $html.children('div').each(function () {
                  const merChildId = jQuery(this).attr('id');
                  const $merChild = $targetElement.find('#' + merChildId);

                  if ($merChild.data('gfrow') != undefined) {
                    data = $merChild.data('gfrow').export('clone');
                  } else if ($merChild.data('gfmodule') != undefined) {
                    data = $merChild.data('gfmodule').export('clone');
                  } else if ($merChild.data('gfelement') != undefined) {
                    data = $merChild.data('gfelement').export('clone');
                  }

                  html += data.html;
                  bkHtml += data.bkHtml;
                });

                extra.childData = {
                  html: html,
                  bkHtml: bkHtml,
                };
                $gryffEditor.data('gfhistory').addHistory('repeator', $targetElement.attr('id'), extra);

                if ($targetElement) {
                  const extraCount = {
                    label: $targetElement.attr('data-label'),
                    name: 'delete-repeator',
                  };
                  if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                    $gryffEditor.data('gfcount').add('setting', extraCount);
                  }
                }

                index = parseInt(index);
                _jsonData['items'].splice(index, 1);

                // Assign _jsonData to dataHolder after item removed from _jsonData
                dataHolder = JSON.stringify(_jsonData);

                _this.initWithJson();
                _isRender = true;
                const dataChanged = _this.saveJsonToModule();
                _this.settings.detectChange(dataChanged);
                // HELPER.clearContentBk();

                return false;
              }

              $li.find('.gfRP_confirm_remove').removeClass('show');
              $li.find('.gfRP_confirm_remove button[data-action="cancel"]').off('click');
              $li.find('.gfRP_confirm_remove button[data-action="delete"]').off('click');
            });
          return false;
        });

      // Add items
      $element
        .find('.rp-clone')
        .off('click')
        .on('click', function () {
          const $that = $(this);

          const $li = $that.parent().parent('.item');
          const $fakeItem = $li.clone();

          let index = $li.attr('index');

          // history
          const extra = {
            items: dataHolder,
          };
          $gryffEditor.data('gfhistory').addHistory('repeator', $targetElement.attr('id'), extra);

          if ($targetElement) {
            const extraCount = {
              label: $targetElement.attr('data-label'),
              name: 'clone-repeator',
            };
            if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
              $gryffEditor.data('gfcount').add('setting', extraCount);
            }
          }

          const itemsArray = jQuery.parseJSON(dataHolder)['items'];
          // Copy object in array without references
          const item = JSON.parse(JSON.stringify(itemsArray[index]));

          // Change name fake
          let _text = $li.find('.gfRP_title').text();
          _text = _this.getName(_text, itemsArray.length);
          $fakeItem.find('.gfRP_title').text(_text);
          if (item['name'] != undefined) {
            $li.after($fakeItem);
          } else {
            $li.parent('.items').append($fakeItem);
          }

          setTimeout(function () {
            // Detect if its tabs module then show all detached tabs
            // before export
            // see in the end of this function as well
            if ($targetElement != undefined && $targetElement.data('gfmodule') != undefined) {
              const moduleName = $targetElement.data('gfmodule').getModuleName();
              if (moduleName == 'Tabs') {
                const moduleId = $targetElement.data('gfmodule').getModuleId();
                const moduleIdSlug = moduleId.toString().replace(/-/g, '');

                const func = 'getTab' + moduleIdSlug;
                if (document.getElementById('gfFrame').contentWindow[func]) {
                  document.getElementById('gfFrame').contentWindow[func]().showAllDetaches(true);
                }
              }
            }

            // change name ++;
            if (item['name'] != undefined) {
              item['name'] = _this.getName(item['name'], itemsArray.length);
            } else if (item.label && item.label.name) {
              // Use for gfOptions
              item.label.default_value = _this.getName(item.label.default_value, itemsArray.length);
            }

            // display the key and value pair
            jQuery.each(item, function (k, v) {
              if (k == 'id') {
                item.id = 'i-' + HELPER.MakeId();
              } else {
                let html = '';
                let bkHtml = '';

                const $contentWrapper = jQuery('<div />').html(item[k]);
                $contentWrapper.children('.gf_row, .module-wrap, .element-wrap').each(function () {
                  if (jQuery(this).attr('data-id') != undefined) {
                    const id = jQuery(this).attr('data-id');

                    let data = {
                      html: '',
                      bkHtml: '',
                    };

                    if (jQuery(this).hasClass('gf_row')) {
                      if ($gryffBody.find('#r-' + id).length > 0) {
                        if ($gryffBody.find('#r-' + id).data('gfrow') != undefined) {
                          data = $gryffBody
                            .find('#r-' + id)
                            .data('gfrow')
                            .export('clone');
                        }
                      }
                    } else if (jQuery(this).hasClass('module-wrap')) {
                      if ($gryffBody.find('#m-' + id).length > 0) {
                        if ($gryffBody.find('#m-' + id).data('gfmodule') != undefined) {
                          data = $gryffBody
                            .find('#m-' + id)
                            .data('gfmodule')
                            .export('clone');
                        }
                      }
                    } else if (jQuery(this).hasClass('element-wrap')) {
                      if ($gryffBody.find('#e-' + id).length > 0) {
                        if ($gryffBody.find('#e-' + id).data('gfelement') != undefined) {
                          data = $gryffBody
                            .find('#e-' + id)
                            .data('gfelement')
                            .export('clone');
                        }
                      }
                    }
                    html += data.html;
                    bkHtml += data.bkHtml;
                  }
                });

                if (html != '' && bkHtml != '') {
                  const rData = HELPER.replaceIds(html, bkHtml);
                  html = rData.html;
                  bkHtml = rData.bkHtml;

                  HELPER.addContentBk(bkHtml);

                  const $html = jQuery('<div />').html(html);
                  $html.find('.module-wrap').html('');
                  html = $html.html();

                  item[k] = html;
                }
              }
            });

            // Add item;
            index = parseInt(index) + 1;
            itemsArray.splice(index, 0, item);

            _jsonData['items'] = itemsArray;

            // Update to dataHolder
            dataHolder = JSON.stringify(_jsonData);

            _this.initWithJson();
            _isRender = true;
            const dataChanged = _this.saveJsonToModule();
            _this.settings.detectChange(dataChanged);
          }, 20);

          return false;
        });

      //Change name;
      if ($element.find('input[name="name"]').length > 0) {
        $element.find('input[name="name"]').on('input-change', function () {
          const $that = $(this);
          const value = $that.attr('value');
          const $dad = $that.parents('.item');
          $dad.find('.gfRP_title').text(value);
          const index = $dad.attr('index');

          _jsonData['items'][index]['name'] = value;
          _this.saveJsonToModule();
        });
      }

      // Hover item;
      let $mer;
      let delayShowTool;
      $element.find('.item').on('mouseenter', function () {
        const $that = $(this);
        clearTimeout(delayShowTool);
        delayShowTool = setTimeout(function () {
          const index = $that.attr('index');
          if (
            $targetElement &&
            $targetElement.find('.item-content[data-index="' + (parseInt(index) + 1) + '"]').length > 0
          ) {
            const $childElement = $targetElement
              .find('.item-content[data-index="' + (parseInt(index) + 1) + '"]')
              .eq(0);

            $mer = $childElement.children('.gf_row, .module-wrap, .element-wrap');
            if ($mer.data('gfrow') != undefined) {
              $mer.data('gfrow').showTool(true);
            } else if ($mer.data('gfmodule') != undefined) {
              $mer.data('gfmodule').showTool(true);
            } else if ($mer.data('gfelement') != undefined) {
              $mer.data('gfelement').showTool(true);
            }
          }
        }, 60);
      });

      $element.find('.item').on('mouseleave', function () {
        clearTimeout(delayShowTool);
        if ($mer) {
          if ($mer.data('gfrow') != undefined) {
            $mer.data('gfrow').hideTool();
          } else if ($mer.data('gfmodule') != undefined) {
            $mer.data('gfmodule').hideTool();
          } else if ($mer.data('gfelement') != undefined) {
            $mer.data('gfelement').hideTool();
          }
        }
      });
    };

    this.saveJsonToModule = function (jsonData) {
      if (jsonData != undefined) {
        _jsonData = jsonData;
        _isRender = true;
      }
      return JSON.stringify(_jsonData, null, 4);
    };

    this.getJsonData = function () {
      return _jsonData;
    };

    this.getName = function (name, count) {
      if (!name) {
        return name;
      }
      name = name.replace(/\d/g, '');
      name = name.trim();
      name += ' ' + (count + 1);

      return name;
    };
    this.init();
  };

  jQuery.fn.gfRepeator = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfrepeator')) {
        const plugin = new jQuery.gfRepeator(this, options);
        jQuery(this).data('gfrepeator', plugin);
      }
    });
  };
})(jQuery);
